var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"bar"},_vm._l((6),function(i){return _c('div',{key:i,staticClass:"item",style:({
                backgroundColor: _vm.calColor(i-1),
                width: ((_vm.data[i-1] * 1000 / _vm.total) + "px")
            })})}),0),_c('div',{staticClass:"intro"},_vm._l((6),function(i){return _c('span',{key:i,staticClass:"token"},[_c('div',{staticClass:"rect",style:({ backgroundColor: _vm.calColor(i-1) })}),_vm._v(" "+_vm._s(_vm.text[i-1])+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }